import React, { useEffect, useState } from 'react'
import { Table } from 'antd'
import apiClient from 'src/Common/apiClient'
import 'src/Pages/LibraryPages/librarypages.scss'

const AssignedStudents = () => {
  const [assignedStudents, setAssignedStudents] = useState([])
  const [loading, setLoading] = useState(true)
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10, total: 0 })

  useEffect(() => {
    fetchMentorGroups(1, 10)
  }, [])

  const fetchMentorGroups = async (pageNumber, pageSize) => {
    try {
      const response = await apiClient.get('/InternshipGroup/Student/List', {
        params: { pageNumber, pageSize, orderByLatest: true },
      })
      const data = response.data
      const items = Array.isArray(data) ? data : data?.items ?? []
      setAssignedStudents(items)
      setPagination({
        current: data?.pageNumber ?? pageNumber,
        pageSize: data?.pageSize ?? pageSize,
        total: data?.totalCount ?? items.length,
      })
    } catch {
      setAssignedStudents([])
    } finally {
      setLoading(false)
    }
  }

  const columns = [
    {
      title: 'Student ID',
      key: 'studentId',
      render: (_, record) => record.studentPublicId || record.studentId,
    },
    {
      title: 'Student Name',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Academic Year',
      dataIndex: 'academicYear',
      key: 'academicYear',
    },
    {
      title: 'Group Name',
      dataIndex: 'groupName',
      key: 'groupName',
    },
    {
      title: 'Start Date',
      dataIndex: 'startDate',
      key: 'startDate',
      render: (text) => new Date(text).toLocaleDateString(),
    },
    {
      title: 'End Date',
      dataIndex: 'endDate',
      key: 'endDate',
      render: (text) => new Date(text).toLocaleDateString(),
    },
  ]

  return (
    <div className="lpg">
      <div className="lpg__head">
        <div className="lpg__head-main">
          <span className="lpg__head-ic">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
              <circle cx="9" cy="7" r="4" />
              <path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" />
            </svg>
          </span>
          <div>
            <h1 className="lpg__title">Assigned Students</h1>
            <p className="lpg__sub">Students assigned to you.</p>
          </div>
        </div>
      </div>

      {loading ? (
        <div className="lpg__state">
          <div className="lpg__spin" />
          Loading...
        </div>
      ) : (
        <div className="lpg__panel-box">
          <Table
            dataSource={assignedStudents}
            columns={columns}
            bordered
            rowKey="memberId"
            pagination={{
              current: pagination.current,
              pageSize: pagination.pageSize,
              total: pagination.total,
              showSizeChanger: true,
              onChange: (pageNumber, pageSize) => {
                setLoading(true)
                fetchMentorGroups(pageNumber, pageSize)
              },
            }}
          />
        </div>
      )}
    </div>
  )
}

export default AssignedStudents
